
export default "/assets/credit-card-micro.38157604.svg"